import { Menu } from 'lucide-react';
import { useSidebar } from '@/contexts/SidebarContext';
import { useAuth } from '@/hooks/useAuth';
import { useUserProfile } from '@/hooks/queries/useUser';

export function MobileTopBar() {
  const { openMobileSidebar } = useSidebar();
  const { user } = useAuth();
  const { data: userProfile } = useUserProfile();

  const email = user?.email ?? '';
  const initial = (userProfile?.firstName?.[0] ?? email[0] ?? 'U').toUpperCase();

  return (
    <div className="lg:hidden flex items-center justify-between h-12 px-4 bg-white border-b border-gray-200 shrink-0">
      <button
        type="button"
        onClick={openMobileSidebar}
        className="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
        aria-label="Open navigation menu"
      >
        <Menu className="h-5 w-5" />
      </button>
      <span className="text-sm font-bold text-gray-900 tracking-tight">Arterra AI</span>
      <div className="w-7 h-7 rounded-full bg-[#1e3a5f] text-white flex items-center justify-center text-xs font-semibold">
        {initial}
      </div>
    </div>
  );
}
